import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

export const staffService = {
	
	// Returns all staff information for a study
	getAllStaff,

	// Returns staff names for a study based on name and/or role criteria
    getStaffNames,

	// Returns all staff names for a study
    getAllStaffNames,

	// Represent GEO_JSON object which represents staff home address based on: study & staff Id
	getStaffHome
};

// #region  staff

function getAllStaff(study) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`staff/?format=json&studyCode=${study}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getStaffNames(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`staff/names/?studyCode=${criteria.study}&name=${criteria.staffname}&role=${criteria.staffrole}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}


function getAllStaffNames(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`staff/names/?studyCode=${criteria.study}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getStaffHome(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`address/find?studyCode=${criteria.study}&staffId=${criteria.staffId}&format=GEO_JSON`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion staff
